/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_No_Cargos_SelectedInputs */

const en_cargos_no_cargos_selected = /** @type {(inputs: Cargos_No_Cargos_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cargos selected`)
};

const es_cargos_no_cargos_selected = /** @type {(inputs: Cargos_No_Cargos_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay cargas seleccionadas`)
};

/**
* | output |
* | --- |
* | "No cargos selected" |
*
* @param {Cargos_No_Cargos_SelectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_no_cargos_selected = /** @type {((inputs?: Cargos_No_Cargos_SelectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_No_Cargos_SelectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_no_cargos_selected(inputs)
	return es_cargos_no_cargos_selected(inputs)
});